import { EnumWidgets } from "../../../../libs/logging/types/loggingTypes";

export interface IHome {
  data: IHomeData;
  _meta: IHomeMeta;
}

export interface IHomeMeta {
  image_placeholder?: string;
  listing_image_placeholder: string;
  taxonomy_image_placeholder: string;
}

export interface IHomeData {
  reels_widget?: ReelsWidget[];
  spotlights?: ISpotlight[];
  taxonomy: ITaxonomy;
  widget: IWidget[];
}

export interface ReelsWidget {
  reels: IReel[];
  member: IMember;
}

export interface IMember {
  id: number;
  full_name: string;
  profile_picture: string;
  is_following: boolean;
}

export interface IReel {
  id: number;
  uri: string;
  thumbnail_uri: string;
  inserted_date_text: string;
  inserted_date_ts: number;
  mime_type: string;
  post: IPost;
}

export interface IPost {
  category: string;
  subCategory: string;
  country: string;
  city: string;
  neighborhood: string;
  currentPaidFeature: null;
  id: number;
  title: string;
  post_url: string;
  bookmarkStatus: boolean;
  internationalPhone: string;
  isMemberReported: null;
  contactAddon: IContactAddon;
}

export interface IContactAddon {
  sms: ISMS;
  whatsapp: ISMS;
}

export interface ISMS {
  enabled: boolean;
  phone_number: string;
  message: string;
}

export interface ISpotlight {
  id: number;
  link: string;
  status: number;
  country_code: string;
  start_date: Date;
  end_date: Date;
  count: number;
  platform: number;
  image: string;
  image_ar: string;
  image_en: string;
  main_text: null;
  main_text_ar: null;
  main_text_en: null;
  sub_text: null;
  sub_text_ar: null;
  sub_text_en: null;
  cta_label: null;
  cta_label_ar: null;
  cta_label_en: null;
  cancel_label: null;
  cancel_label_ar: null;
  cancel_label_en: null;
  type: number;
  screen: string;
  order: number;
  main_text_color: null;
  sub_text_color: null;
  cta_text_color: null;
  btns_color: null;
  element: null;
  next_spotlight: null;
  web_link: null;
  activity_name: null;
  cell_infos: null;
}

export interface ITaxonomy {
  title?: string;
  items: ITaxonomyItem[];
  gtm?: IGtmHome;
}

export interface ITaxonomyItem {
  key: string;
  label: string;
  deeplink: string;
  icon: string;
  reporting_name: string;
  weblink: string;
  tag_label_ar: string;
  tag_label_en: string;
  tag_show: boolean;
}

export interface IWidget {
  type: IWidgetTypes;
  banner_key?: string;
  label?: string;
  sub_label?: string;
  view_type?: "default" | "no-image";
  key?: string;
  sub_links?: ITags[];
  weblink?: string;
  deeplink?: string;
  items?: IWidgetItem[];
  link?: ILink;
  codename: string;
  category_reporting_name: string;
  price?: string;
  currency:string
  gtm_config: IGtmHome;
}

export type IWidgetTypes = "listings" | "openshop" | "add_listing" | "banner";

export interface ILink {
  gtm_object: {
    Category: string;
  };
  deeplink: string;
  weblink: string;
}

export interface IWidgetItem {
  id: number;
  title: string;
  post_url: string;
  image: string;
  price: string;
  highlights: string;
  category_reporting_name: string;
  subcategory_reporting_name: string;
  cv_id?: string;
  currency?:string;
  city_reporting_name: string;
  neighborhood_reporting_name: string;
  member_id:number;
}

export interface ITags {
  label: string;
  weblink: string;
  subcategory_reporting_name: string;
}

export interface IGtmHome {
  title: IGtmData;
  see_more: IGtmData;
  post: IGtmData;
  sub_links?: IGtmData;
}

export interface IGtmData {
  eventAction: string;
  eventLabel: string;
  widgetName: EnumWidgets;
}

export enum EnumUrlRefs {
  CONTINUE_BROWSING = "ContinueBrowsingHome",
  RECOMMENDED = "RecommendedHome",
  RECENTLY = "RecentlyBlock",
}
